import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import DashboardGridBox from '../DashboardGridBox.jsx';
import { toCommaNumber } from '../../../utils/format';

class LiabilityLimits extends DashboardGridBox {
    static propTypes = {
        selections: ImmutablePropTypes.list,
        status: PropTypes.string,
        limitWarning: PropTypes.number.isRequired,
        limitWarningStatus: PropTypes.string.isRequired,
        getLiabilitiesLimits: PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.title = 'Liability Limits';

        this.columns = [
            {
                name: 'name',
                label: 'Selection',
                width: 8
            },
            {
                name: 'liability',
                label: 'Liability',
                width: 2,
                class: 'widget-table__column-right'
            },
            {
                name: 'limit',
                label: 'Liab limit',
                width: 2,
                class: 'widget-table__column-right'
            }
        ];

        this.data = [];
    }

    UNSAFE_componentWillReceiveProps(props) {
        // Don't update the widget data unless the
        // widget settings is retrieved and the limits request has finished
        if ( props.limitWarningStatus === 'FINISHED' && props.status === 'FINISHED') {
            this.buildData(props);
        }

        // Start again the updates
        // when the customer is close/minimizez
        if ( props.stopTick !== this.props.stopTick ) {
            this.startTickUpdate(props);
        }
    }

    componentDidMount() {
        this.startTickUpdate(this.props);
    }

    startTickUpdate(props) {
        clearInterval(this.refresh);

        if ( props.stopTick ) {
            return;
        }

        props.getLiabilitiesLimits();

        this.refresh = setInterval(() => {
            if (props.status === 'FINISHED') {
                props.getLiabilitiesLimits();
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.refresh);
    }

    onClickRedirect(data, route, event) {
        event.preventDefault();

        let { eventId, marketId } = data;

        let path = '';
        let params = {
            market: parseInt(marketId, 10)
        };

        if ( route === 'liabilities') {
            path = '/trading?tab=liabilities&liabilities=single&liabilities';
            params = {
                ...params,
                event: parseInt(eventId, 10)
            };
        } else if ( route === 'market' ) {
            path = `/trading?*events=${eventId}&*events`;
            params = {
                ...params,
                tab: 'markets',
                filter: 'open'
            };
        }


        window.open(path + '.parameters=' + JSON.stringify(params));
    }

    buildData(props) {
        let { selections, limitWarning } = props;

        this.data = selections.reduce( (out, selection) => {
            let price = selection.getIn([ 'selection', 'price' ]);
            let priceLabel = price ? ` (${price.get('priceNum')}/${price.get('priceDen')})` : '';
            let liability = parseFloat(selection.get('liabilities')) / 100;
            let limit = parseFloat(selection.get('liabilityLimit')) / 100;
            let overflow = parseFloat(selection.get('overflow'));

            let priority = 2;

            if ( overflow > 100) {
                priority = 0;
            } else if ( overflow >= limitWarning * 100 ) {
                priority = 1;
            }

            return out.concat([
                {
                    key: selection.getIn([ 'selection', 'id' ]) + selection.getIn([ 'market', 'id' ]),
                    priority,
                    eventId: parseInt(selection.getIn([ 'event', 'id' ]), 10),
                    marketId: parseInt(selection.getIn([ 'market', 'id' ]), 10),

                    liability,
                    limit,
                    name: selection.getIn([ 'selection', 'name' ]) + `${priceLabel}`,
                    event: selection.getIn([ 'event', 'name' ]) + ' - ' + selection.getIn([ 'market', 'name' ])
                }
            ]);
        }, []);
    }

    renderTable() {
        const priorities = [ 'critical', 'warning', '' ];

        const liabilityHeader = (
            <div className="widget-table__header" key="liability-header">
                <div className="row">
                    {
                        this.columns.map(col => {
                            return <div className={`col-${col.width} ${col.class}`} key={col.name}>{ col.label }</div>;
                        })
                    }
                </div>
            </div>
        );

        const liabilityRows = this.data.map(item => {
            return (
                <div className={`widget-table__row ${priorities[item.priority]}`} key={ item.key }>
                    <div className="row">
                        <div className="col-8">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'market')}>
                                <strong>{ item.name }</strong>
                            </a>
                        </div>

                        <div className="col-2 widget-table__column-right">
                            <a href="" onClick={this.onClickRedirect.bind(this, item, 'liabilities')}>
                                <strong>{ toCommaNumber(parseInt(item.liability, 10)) }</strong>
                            </a>
                        </div>

                        <div className="col-2 widget-table__column-right">
                            <strong>{ toCommaNumber(parseInt(item.limit, 10)) }</strong>
                        </div>

                        <div className="col-12 widget-table__text-small">
                            { item.event }
                        </div>
                    </div>
                </div>
            );
        });

        return [ liabilityHeader, ...liabilityRows ];
    }

    renderElement() {
        const { status } = this.props;
        const count = this.data.length;

        let spinner = null;
        if ( status === 'IN_PROGRESS' && count === 0 ) {
            spinner = <div className="spinner spinner--inline"> </div>;
        }

        const message = status === 'FINISHED' && count === 0 ? (
            <div className="widget-table__not-found">
                No liability limits
            </div>
        ) : null;

        return (
            <div className="liability-limits widget-table">
                { message }
                { spinner }
                { count ? this.renderTable() : null }
            </div>
        );
    }
}

LiabilityLimits.WIDTH = 4;
LiabilityLimits.HEIGHT = 8;
LiabilityLimits.X = 0;
LiabilityLimits.Y = 0;

export default LiabilityLimits;
